import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import bdapi from "@bd-core/bd-api";
import CONFIG from "@bd-core/config";
import Storage from "@bd-utils/storage";

export default class Debriefing {
    constructor() {
        this.elms = {
            submitDebrief: "#submitDebrief",
            finishDebrief: "#finishDebrief",
            form: ".js-debriefing-form",
            debriefingItems: ".debriefing__wrap",
            nextDebrief: ".next-debrief-btn",
            backDebrief: ".back-debrief-btn",
            questionItem: ".debriefing__item",
            questionWrapper: ".question",
            debriefItem: ".debriefing__item",
            message: ".js-message",
            name: ".js-name",
            text: ".js-text",
            sendBtn: ".js-send-btn",
            input: ".js-input",
            chatInner: ".js-chat-inner",
            resetBtn: ".js-restart-game",
            footer: ".js-footer"
        };

        this.slickOpts = {
            arrows: false,
            swipe: false,
            centerMode: true,
            dots: false,
            loops: false,
            infinite: false,
        };

        this.isLoading = false;
        return this;
    }

    init() {
        const elms = this.elms;

        // @ts-ignore
        $(elms.debriefingItems).slick(this.slickOpts);
        $(elms.form).on("submit", this._onFormSubmited.bind(this));
        $(elms.backDebrief).on("click", this._goToPreviousItem.bind(this));
        $(elms.finishDebrief).on("click", this._finishDebriefing.bind(this));

        $(elms.form).on(
            "change",
            'input[type="radio"]',
            this._removeErrorState,
        );
        $(elms.form).on(
            "input",
            ['input[type="text"]', 'input[type="email"]'].join(","),
            this._removeErrorState,
        );

        $(elms.sendBtn).on("click", this._sendMessageFromUser.bind(this));

        // $(document).on("keypress", elms.input, function (e) {
        //     const key = e.which || e.keyCode || 0;
        //     const isEnterKey = key == 13;
        //     if (isEnterKey && !e.shiftKey) {
        //         e.preventDefault();
        //         $(elms.sendBtn).trigger("click");
        //         return false;
        //     }
        // });

        this.setAnsweredDebriefing();
    }

    _finishDebriefing() {
        if (this.isLoading) return;

        $(".resultPage").removeClass("is-debriefing");
    }

    _removeErrorState(e) {
        const $el = $(e.currentTarget);
        const $questionAnswer = $el.parents(".question").first();

        $questionAnswer.removeClass(["has-error", "has-validation-error"]);
    }

    _goToPreviousItem() {
        $(this.elms.debriefingItems).slick("slickPrev");
    }

    _onFormSubmited(e) {
        // prettier-ignore
        // eslint-disable-next-line
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $questionItem = $this.parents(elms.questionItem);
        const $wrapper = $this.find(elms.questionWrapper);
        const questionType = $questionItem.data("type-question");
        const inputType = $questionItem.find("input").attr("type");
        const slick = $(elms.debriefingItems).slick("getSlick");
        const isLastSlide = slick.currentSlide === slick.slideCount - 1;
        let isAnswered = true;

        if (questionType !== "plain_text") {
            let answer = "";

            if (inputType === "text" || inputType === "email") {
                answer = String($questionItem.find("input").val());
            } else {
                answer = String(
                    $questionItem.find("input[type=radio]:checked").val() ?? "",
                );
            }

            if (answer.trim() === "" || answer === "undefined") {
                isAnswered = false;
                $wrapper.addClass("has-error");
            } else if (inputType === "email") {
                const isValidEmail = emailRegex.test(answer);
                $wrapper.toggleClass("has-validation-error", !isValidEmail);
                isAnswered = isValidEmail;
            }
        }

        if (isAnswered === true) {
            $wrapper.removeClass(["has-error", "has-validation-error"]);

            if (isLastSlide) {
                this._submitDebriefing();
            } else {
                $(elms.debriefingItems).slick("slickNext");
            }
        }
        return false;
    }

    async _submitDebriefing() {
        const elms = this.elms;
        const $input = $(elms.input);
        const $submitBtn = $(elms.sendBtn);
        
        $input.prop("disabled", true);
        $submitBtn.prop("disabled", true);

        if (this.isLoading) return;

        this.isLoading = true;

        const $userAnswers = $(".js-message.is-user");
        const answers = [];

        $.each($userAnswers, function (index, answer) {
            const $answer = $(answer);
            const questionID = $answer.attr("data-question-id");
            const answerText = $answer.find(elms.text).text();

            answers.push({
                question_id: questionID,
                answer: answerText,
            });
        });

        const [res] = await bdjs.goAsync(
            bdapi.post("game/submit-debriefing", {
                answers: answers,
            }),
        );

        const resData = res?.data || {};

        if (resData?.success) {
            $(elms.footer).addClass("is-active");
        }

        this.isLoading = false;

        return false;
    }

    getSavedDebriefing() {
        const states = Storage.get("states", {});
        const savedDebriefing = states?.debriefing || {};

        return savedDebriefing;
    }

    setSavedDebriefing(answers) {
        let states = Storage.get("states", {});
        if (!states?.debriefing) states.debriefing = {};

        states.debriefing = answers;

        return Storage.set("states", states);
    }

    saveDebriefing(questionId, answer) {
        const savedDebriefing = this.getSavedDebriefing();
        savedDebriefing[questionId] = answer;

        this.setSavedDebriefing(savedDebriefing);
    }

    _sendMessageFromUser() {
        const elms = this.elms;
        const $submitBtn = $(elms.sendBtn);
        const $messageToBeCloned = $(elms.message + ".to-be-cloned");
        const $innerChat = $(elms.chatInner);
        const $lastMessage = $(elms.chatInner).children().last();
        const questionId = $lastMessage.attr("data-question-id");
        const $newMessage = $messageToBeCloned.clone();
        const $input = $(elms.input);
        const userInput = String($input.val());
        const userName = CONFIG.user.nickname;

        $input.prop("disabled", true);
        $submitBtn.prop("disabled", true);
        $newMessage.removeClass("to-be-cloned");
        $newMessage.addClass("is-user");
        $newMessage.find(elms.name).text(userName);
        $newMessage.find(elms.text).html(userInput);
        $newMessage.attr("data-question-id", questionId);

        $input.val("");
        $lastMessage.after($newMessage);
        $innerChat.animate({ scrollTop: $innerChat.prop("scrollHeight") });

        if (questionId) {
            this.saveDebriefing(questionId, userInput);

            setTimeout(() => {
                this._sendAuraResponse(questionId);
            }, 1500);
        }
    }

    _sendAuraResponse(questionId) {
        const { questions } = CONFIG.game.debriefing;
        const lastIndex = questions.length - 1;
        const question = questions.find(
            (question) => question.id === questionId,
        );
        const nextQuestion = questions[questions.indexOf(question) + 1];

        if (!question) return;

        const { image, response } = question;

        const elms = this.elms;
        const $innerChat = $(elms.chatInner);
        const $messageToBeCloned = $(elms.message + ".to-be-cloned");
        const $lastMessage = $(elms.chatInner).children().last();
        const $responseMessage = $messageToBeCloned.clone();
        const $input = $(elms.input);
        const $submitBtn = $(elms.sendBtn);

        if (image || response ) {
            $responseMessage.removeClass("to-be-cloned");
            $responseMessage.addClass("is-aura");
            $responseMessage.find(elms.name).text("AURA");
    
            if (image) {
                $responseMessage
                    .find(elms.text)
                    .parent()
                    .append(`<img src="${image}" alt="AURA response">`);
            } else {
                $responseMessage.find(elms.text).html(response);
            }

            $lastMessage.after($responseMessage);
            $innerChat.animate({ scrollTop: $innerChat.prop("scrollHeight") });
        }

        if (nextQuestion) {
            const $messageToBeCloned = $(elms.message + ".to-be-cloned");
            const $lastMessage = $(elms.chatInner).children().last();
            const $newMessage = $messageToBeCloned.clone();

            $newMessage.removeClass("to-be-cloned");
            $newMessage.addClass("is-aura");
            $newMessage.find(elms.name).text("AURA");
            $newMessage.attr("data-question-id", nextQuestion.id);

            if(nextQuestion.type === "input_text_with_response") {
                $newMessage.find(elms.text).html(nextQuestion.question);
            } else {
                // @ts-ignore
                $newMessage.find(elms.text).html(nextQuestion.description);
            }

            setTimeout(() => {
                $lastMessage.after($newMessage);
                $innerChat.animate({
                    scrollTop: $innerChat.prop("scrollHeight"),
                });
                $input.prop("disabled", false);
                $submitBtn.prop("disabled", false);

                if (questions.indexOf(nextQuestion) !== lastIndex) return;
                this._submitDebriefing();
            }, 1500);
        }
    }

    setAnsweredDebriefing() {
        const elms = this.elms;

        const { questions } = CONFIG.game.debriefing;
        const userName = CONFIG.user.nickname;
        const $messageToBeCloned = $(elms.message + ".to-be-cloned");
        const $innerChat = $(elms.chatInner);

        const savedDebriefing = this.getSavedDebriefing();

        if (savedDebriefing) {
            for (const [index, item] of questions.entries()) {
                const { id, image, response, question } = item;
                const hasAnswer = savedDebriefing[id] || false;
                const isLastQuestion = questions.indexOf(item) === questions.length - 1;

                if (hasAnswer) {
                    const $lastMessage = $(elms.chatInner).children().last();
                    let $question = $(
                        elms.message + `[data-question-id="${id}"]`,
                    );
                    const isRendered = $question.length > 0;

                    if (!isRendered) {
                        // render question
                        $question = $messageToBeCloned.clone();
                        $question.removeClass("to-be-cloned");
                        $question.addClass("is-aura");
                        $question.find(elms.name).text("AURA");
                        $question.find(elms.text).html(question);
                        $question.attr("data-question-id", id);

                        $lastMessage.after($question);
                        $innerChat.animate({
                            scrollTop: $innerChat.prop("scrollHeight"),
                        });
                    }

                    // render answer
                    const $answer = $messageToBeCloned.clone();
                    $answer.removeClass("to-be-cloned");
                    $answer.addClass("is-user");
                    $answer.find(elms.name).text(userName);
                    $answer.find(elms.text).html(savedDebriefing[id]);
                    $answer.attr("data-question-id", id);

                    $question.after($answer);
                    $innerChat.animate({
                        scrollTop: $innerChat.prop("scrollHeight"),
                    });

                    // render response
                    const $response = $messageToBeCloned.clone();
                    $response.removeClass("to-be-cloned");
                    $response.addClass("is-aura");
                    $response.find(elms.name).text("AURA");
                    $response.find(elms.text).html(response);

                    if (image) {
                        $response
                            .find(elms.text)
                            .parent()
                            .append(`<img src="${image}" alt="AURA response">`);
                    } else {
                        $response.find(elms.text).html(response);
                    }

                    $answer.after($response);
                    $innerChat.animate({
                        scrollTop: $innerChat.prop("scrollHeight"),
                    });

                    if (!isLastQuestion) {
                        // Render the next question in the chat
                        const nextQuestion = questions[index + 1] || false;
                        if (nextQuestion) {
                            const $nextMessage = $messageToBeCloned.clone();
                            $nextMessage.removeClass("to-be-cloned");
                            $nextMessage.addClass("is-aura");
                            $nextMessage.find(elms.name).text("AURA");
                            $nextMessage.find(elms.text).html(nextQuestion.question);
                            $nextMessage.attr("data-question-id", nextQuestion.id);

                            $response.after($nextMessage);
                            $innerChat.animate({
                                scrollTop: $innerChat.prop("scrollHeight"),
                            });
                        }
                    }
                } else if(isLastQuestion && !hasAnswer) {
                    const $lastMessage = $(elms.chatInner).children().last();
                    const lastMessageId = $lastMessage.attr("data-question-id");
                    const isLastMessageHasAnswer = savedDebriefing[lastMessageId] || false;

                    if(!isLastMessageHasAnswer) return;

                    $(elms.footer).addClass("is-active");
                    $(elms.input).prop("disabled", true);
                    $(elms.sendBtn).prop("disabled", true);
                }
            }
        }
    }
}
